/**
 * Decode numeric path coordinates from protobuf JSON.
 * Proto3 omits fields equal to the default (0 for numbers); treat missing as 0
 * so cubic Bézier segments keep their second control point after round-trip.
 * Without this, pathCommandsToSvgPath falls back to quadratic (Q) and shapes like circles warp.
 */

export function readProtoCoord(value: unknown): number {
  if (value == null) return 0
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (typeof value === 'string' && value !== '') {
    const n = Number(value)

    return Number.isFinite(n) ? n : 0
  }

  return 0
}
